<template>
    <v-select
        ref="field"
        v-model="text"
        :label="label"
        :items="items" />
</template>

<script>
import SelectFocus from '@/modules/line/mixin/SelectFocus'

export default {
    name: 'kus-line-search-pay-status',
    mixins: [SelectFocus],
    props: {
        value: { type: String },
        label: { type: String }
    },
    mounted() {
        this.$nextTick(() => this.mixinFocus())
    },
    computed: {
        text: {
            get() {
                return this.value
            },
            set(v) {
                this.$emit('input', v)
            }
        },

        items() {
            const status = this.$i18n.t('lines.payStatus')
            return Object.entries(status).map(d => ({
                value: d[0],
                text: d[1]
            }))
        }
    },
    methods: {
        focus() {
            this.mixinFocus()
        }
    }
}
</script>
